// AppShell wraps the app with the TopNav and a consistent page container.
// Use it to wrap your route <Outlet />.

import * as React from "react";
import { Outlet } from "react-router-dom";
import TopNav from "./TopNav";

interface AppShellProps {
  userName?: string;
  userGroups?: string[];
  onLogout?: () => void;
}

const AppShell: React.FC<AppShellProps> = ({ userName, userGroups, onLogout }) => {
  return (
    <div className="min-h-[100dvh] bg-background">
      <TopNav userName={userName} userGroups={userGroups} onLogout={onLogout} />
      {/* Main content area */}
      <main className="mx-auto px-4 md:px-6 py-6 md:py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AppShell;
